module.exports = __webpack_public_path__ + "media/assets/images/flags/pl-e9488bdb5e38e3ebc56aba8a21db545e.svg";